<div [ngClass]="containerClass" class="text-center p-4 rounded">
  <div class="empty-data-icon mb-2" *ngIf="icon">
    <i [ngClass]="icon" [ngStyle]="{'font-size': iconSize, 'color': iconColor}"></i>
  </div>
  <div class="empty-data-message">
    <h4 [ngStyle]="{'font-size': titleSize, 'color': titleColor}">{{ title }}</h4>
    <p [ngStyle]="{'font-size': messageSize, 'color': messageColor}">{{ message }}</p>
  </div>
</div>
